import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {

    title: string;
    texts: Array<string>;
    bodyClass: string;
    textBtnConfirm = 'system.confirm';
    textBtnCancel = 'system.cancel';
    showBtnConfirm = true;
    showBtnCancel = true;
    iconPath = '../../../../assets/images/info-icon.svg';

    @Output() cancelEmitter: EventEmitter<any> = new EventEmitter();
    @Output() confirmEmitter: EventEmitter<any> = new EventEmitter();

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialog: MatDialogRef<ConfirmDialogComponent>,
    ) {
        if (data) {
            this.title = data.title;
            this.texts = data.texts ?? [];
            if (data.text) {
                this.texts.push(data.text);
            }
            this.bodyClass = data.bodyClass;
            this.textBtnConfirm = data.textBtnConfirm ? data.textBtnConfirm : this.textBtnConfirm;
            this.textBtnCancel = data.textBtnCancel ? data.textBtnCancel : this.textBtnCancel;
            this.showBtnConfirm = data.showBtnConfirm !== undefined ? data.showBtnConfirm : this.showBtnConfirm;
            this.showBtnCancel = data.showBtnCancel !== undefined ? data.showBtnCancel : this.showBtnCancel;
            this.iconPath = data.iconPath ? data.iconPath : this.iconPath;
        }
    }

    cancel() {
        this.cancelEmitter.emit();
        this.dialog.close(false);
    }

    confirm() {
        this.confirmEmitter.emit();
        this.dialog.close(true);
    }

}
